// GTM handles page_view tracking automatically - no manual tracking needed
const GoogleAnalytics = () => {
  // GTM with Enhanced Measurement handles all page views
  // No initialization or manual tracking required
  return null;
};

// Re-export lazy analytics functions
export { 
  trackEvent, 
  trackConversion, 
  trackFormSubmit, 
  trackCTAClick, 
  trackServiceInterest 
} from '@/lib/analytics-lazy';

export default GoogleAnalytics;